// src/components/OurRelevantMarketingCampaigns.js
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  Container
} from '@mui/material';

const OurRelevantMarketingCampaigns = () => {
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ py: { xs: 4, md: 8 }, textAlign: 'center' }}>
      {/* Título de la sección */}
      <Typography 
        variant="h3" 
        align="center" 
        gutterBottom 
        sx={{
          fontWeight: 'bold',
          color: 'rgb(3,116,206)',
          fontSize: { xs: '2rem', md: '3rem' }
        }}
      >
        Our Relevant Marketing Campaigns
      </Typography>
      {/* 3 Logos en fila */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: { xs: 2, md: 4 },
          mb: 4,
          flexWrap: 'wrap'
        }}
      >
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/kioxia.png`}
          alt="Kioxia Logo"
          sx={{ width: { xs: '6rem', md: '12rem' } }}
        />
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/amd.png`}
          alt="AMD Logo"
          sx={{ width: { xs: '6rem', md: '12rem' } }}
        />
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/bequiet.png`}
          alt="BeQuiet! Logo"
          sx={{ width: { xs: '6rem', md: '12rem' } }}
        />
      </Box>
      {/* Botón para abrir el popup */}
      <Button
        variant="contained"
        onClick={handleOpenDialog}
        sx={{ backgroundColor: 'rgb(139,206,252, 0.45)', color: 'black', width: '20rem', height: '3rem', fontWeight:'bold', fontSize: 'large' }}
      >
        Click here to discover it
      </Button>

      {/* Popup (Dialog) */}
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        PaperProps={{
          sx: { width: '100%', m: 'auto', marginLeft: '0', marginRight:'0', maxWidth:'75rem' }  // 90% del ancho de la pantalla, centrado
        }}
      >
        <DialogContent>
          <Container maxWidth="md">
            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  backgroundColor: 'rgb(139,206,252, 0.45)',
                  width: '100%',
                  py: 1
                }}
              >
                <Typography variant="h4" align="center" sx={{ color: 'black', fontWeight: 'bold' }}>
                  Colaboration ASUS & KIOXIA
                </Typography>
              </Box>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/asus.png`}
                  alt="AMD Campaign"
                  sx={{ width: '100%', maxWidth: '30rem', mx: 'auto' }}
                />
              </Box>
            </Box>
            {/* Sección Kioxia */}
            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  backgroundColor: 'rgb(139,206,252, 0.45)',
                  width: '100%',
                  py: 1
                }}
              >
                <Typography variant="h4" align="center" sx={{ color: 'black', fontWeight: 'bold' }}>
                  KIOXIA
                </Typography>
              </Box>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/kioxia1.png`}
                  alt="Kioxia 1"
                  sx={{ width: '100%', maxWidth: '50rem', mx: 'auto' }}
                />
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/kioxia2.png`}
                  alt="Kioxia 2"
                  sx={{ width: '100%', maxWidth: '50rem', mx: 'auto' }}
                />
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/kioxia3.png`}
                  alt="Kioxia 3"
                  sx={{ width: '100%', maxWidth: '50rem', mx: 'auto' }}
                />
              </Box>
            </Box>

            {/* Sección AMD */}
            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  backgroundColor: 'rgb(139,206,252, 0.45)',
                  width: '100%',
                  py: 1
                }}
              >
                <Typography variant="h4" align="center" sx={{ color: 'black', fontWeight: 'bold' }}>
                  AMD
                </Typography>
              </Box>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/amd1.png`}
                  alt="AMD Campaign"
                  sx={{ width: '100%', maxWidth: '30rem', mx: 'auto' }}
                />
              </Box>
            </Box>

            {/* Sección BeQuiet! */}
            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  backgroundColor: 'rgb(139,206,252, 0.45)',
                  width: '100%',
                  py: 1
                }}
              >
                <Typography variant="h4" align="center" sx={{ color: 'black', fontWeight: 'bold' }}>
                  BeQuiet!
                </Typography>
              </Box>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/bequiet1.png`}
                  alt="BeQuiet 1"
                  sx={{ width: '100%', maxWidth: '50rem', mx: 'auto' }}
                />
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/bequiet2.png`}
                  alt="BeQuiet 2"
                  sx={{ width: '100%', maxWidth: '50rem', mx: 'auto' }}
                />
              </Box>
            </Box>
          </Container>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default OurRelevantMarketingCampaigns;
